import _ from 'lodash'

export const GET_EXPORT = 'GET_EXPORT'
export const GET_EXPORT_REQUEST = (module, id, type) =>
    `GET_${_.toUpper(module)}_${_.toUpper(id)}_${_.toUpper(type)}_EXPORT_REQUEST`

export const LOCALE_PREFIX = 'scenes.Gnosus.components.Toolbar.components.HocExports'
export const EXPORT_LOADER_ID = 'exportLoader'
